export const LANGUAGE_COOKIE = "NEXT_LOCALE";
